import { render, staticRenderFns } from "./RoomToExamine.vue?vue&type=template&id=3a347b6c"
import script from "./RoomToExamine.vue?vue&type=script&lang=js"
export * from "./RoomToExamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports